<kendo-dialog-titlebar>
    {{'claims-center.claimDocumentation.selectDocumentationType' | translate}}
</kendo-dialog-titlebar>



<div class="is-proof-switch">
    <kendo-switch [(ngModel)]="isProofDocument" (valueChange)="isProofDocumentValueChanged($event)"
        class="button-with-margin">
    </kendo-switch>
    {{'claims-center.claimDocumentation.isProofDocument' | translate}}
</div>


<form [formGroup]="documentDataForm">
    <div fxLayout="column" fxLayoutGap='15px'>

        <div *ngIf="!isProofDocument">

            <static-dictionary-text-autocomplete-ctrl [caption]="'claims-center.claimDocumentation.claimDocumentKind'"
                [formControlName]="'documentKindId'" [staticDictionaryName]="'documentKind'" [settings]="{fxFill:true}"
                [allowCustom]="false" [allowedValueCheck]="checkIfBasicDocumentKind"  (valueChangeEvent)="documentKindChange($event)">
            </static-dictionary-text-autocomplete-ctrl>

        </div>

        <div *ngIf="!!isProofDocument">
            <proof-documents-multiselect-ctrl [caption]="'claims-center.claimDocumentation.proofDocs'"
                [settings]="{fxFill:true}" [formControlName]="'proofDocumentIds'"
                [claimIdentifier]="uploadDocumentParameters.claimIdentifier">
            </proof-documents-multiselect-ctrl>
        </div>

        <div *ngIf="selectedDocumentKindId === otherClaimDocument">
            <text-input-ctrl [caption]="'claims-center.claimDocumentation.otherDocumentKindName'"
                [formControlName]="'otherDocumentKindName'" [settings]="{fxFill:true}">
            </text-input-ctrl>
        </div>

        <text-input-ctrl [caption]="'claims-center.claimDocumentation.description'" [formControlName]="'description'"
            [settings]="{fxFill:true}">
        </text-input-ctrl>

    </div>
</form>


<kendo-dialog-actions>
    <button kendoButton (click)="confirm()" [primary]="true" submit>{{'global.confirm' | translate}}</button>
</kendo-dialog-actions>